"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridPreview = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/code-block/code-block");
require("@/components/common/grid/grid");
require("@/components/common/button/button-group");
require("@/components/common/toggle-button/toggle-button-group");
require("@/components/domains/ui-placeholder/ui-placeholder");
const COLUMNS_OPTIONS = [
    { value: '2', label: 'columns 2' },
    { value: '3', label: 'columns 3' },
    { value: '4', label: 'columns 4' },
    { value: '6', label: 'columns 6' },
];
const GAP_OPTIONS = [
    { value: '1', label: 'gap 1' },
    { value: '2', label: 'gap 2' },
    { value: '4', label: 'gap 4' },
];
const ITEM_COUNT = 6;
/** Container 문서에서 mm-grid의 columns·gap을 바꿔 가며 배치가 달라지는 모습을 보이는 예제. */
let GridPreview = class GridPreview extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.columns = 3;
        this.gap = '2';
    }
    render() {
        return (0, lit_1.html) `
      <mm-button-group>
        <mm-toggle-button-group
          aria-label="columns"
          .options=${COLUMNS_OPTIONS}
          .value=${String(this.columns)}
          @change=${this.handleColumnsChange}
        ></mm-toggle-button-group>
        <mm-toggle-button-group
          aria-label="gap"
          .options=${GAP_OPTIONS}
          .value=${this.gap}
          @change=${this.handleGapChange}
        ></mm-toggle-button-group>
      </mm-button-group>

      <mm-grid .columns=${this.columns} gap=${this.gap}>
        ${Array.from({ length: ITEM_COUNT }, () => (0, lit_1.html) `
            <mm-ui-placeholder></mm-ui-placeholder>
          `)}
      </mm-grid>

      <mm-code-block .code=${this.buildCode()}></mm-code-block>
    `;
    }
    handleColumnsChange(event) {
        this.columns = Number(event.detail.value);
    }
    handleGapChange(event) {
        this.gap = event.detail.value;
    }
    buildCode() {
        return `<mm-grid columns="${this.columns}" gap="${this.gap}">
  <!-- 반복 항목 -->
</mm-grid>`;
    }
};
GridPreview.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }
  `;
__decorate([
    (0, decorators_js_1.state)()
], GridPreview.prototype, "columns", void 0);
__decorate([
    (0, decorators_js_1.state)()
], GridPreview.prototype, "gap", void 0);
GridPreview = __decorate([
    (0, decorators_js_1.customElement)('mm-grid-preview')
], GridPreview);
exports.GridPreview = GridPreview;
//# sourceMappingURL=data:application/json;base64,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